/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var map = null;

        function new_map( $el ) {
  
          // var
          var $markers = $el.find('.marker');
          
          
          // vars
          var args = {
            zoom    : 16,
            center    : new google.maps.LatLng(0, 0),
            mapTypeId : google.maps.MapTypeId.ROADMAP
          };
          
          
          // create map           
          var map = new google.maps.Map( $el[0], args);
          
          
          // add a markers reference
          map.markers = [];
          
          
          // add markers
          $markers.each(function(){
            
              add_marker( $(this), map );
            
          });
          
          
          // center map
          center_map( map );
          
          
          // return
          return map;
          
        }

        var scrollTo = function(sectionID){
          var scrollPos = $(sectionID).offset().top;
          if($(window).width() < 768){
            $('html,body').animate({scrollTop: scrollPos - 76}, 500);
          }
          else {
            $('html,body').animate({scrollTop: scrollPos - 70}, 500);
          }
        };

        $('.menu-item a:not(.no-js)').on('click', function(e){
          e.preventDefault();
          var activeElem = $(this);
          var thisAttr = activeElem.attr("href");

          scrollTo(thisAttr);
        });

        $('.brand').on('click', function(){
          $('html,body').animate({scrollTop: 0}, 500);
        });

        $('.burgerbar').on('click', function(){
          $(this).toggleClass('active');
          $(this).siblings('.main-nav').toggleClass('active');
        });

        $('.acf-map').each(function(){

          // create map
          map = new_map( $(this) );

        });

        $('#replacement-submit').on('click', function(){
          $('form').find('input[type="submit"]').click();
        });

        $(window).scroll(function(){
          var windowTP = $(window).scrollTop();
          var bodyWrapTP = $('.wrap').offset().top;

              if(windowTP >= bodyWrapTP) {
                $('.fix-nav-primary').addClass('active');
              }
              else {
                $('.fix-nav-primary').removeClass('active');
              }
        });

        $('.slick-slides').each(function(){

          $(this).slick({
            fade: true,
            dots: true,
            arrows: true,
            appendDots: $(this).siblings('.dots-container')
          });

        });

        $('.officeplans-slider').slick({
          fade: true,
          dots: false,
          arrows: true,
        }).on('afterChange', function(event, slick, currentSlide, nextSlide){
          var currentSlideTitle = $('.slick-current').find('.floor-title');

          console.log(currentSlideTitle);

          $('.current-slide-title').empty();
          $('.current-slide-title').append(currentSlideTitle.clone());
        });

        $('.officeplans-nav').on('click', function(){
          gotoSlide = $(this).attr('data-slide');

          $('.officeplans-slider').slick('slickGoTo', gotoSlide);
        });

        var searchText;
        $('.start-loc').keyup(function(){
          searchText = $(this).val().toLowerCase();

          $('.append-loc').each(function(){ 
            $(this).attr('href', 'https://www.google.com/maps?saddr='+searchText+'&daddr=Blaak 34, Rotterdam, Netherlands');
          });

          $('.append-loc-car').each(function(){ 
            $(this).attr('href', 'https://www.google.com/maps?saddr='+searchText+'&daddr=Blaak 34, Rotterdam, Netherlands&dirflg=d');
          });

          $('.append-loc-train').each(function(){ 
            $(this).attr('href', 'https://www.google.com/maps?saddr='+searchText+'&daddr=Blaak 34, Rotterdam, Netherlands&dirflg=r');
          });

        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
